var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n        stroke-width: 0px;\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 100,
    x2: 200,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.2.6c-2.6-.8-5.5-.8-8.1.1L8.4,63.1c-6.5,2.3-9.9,9.5-7.6,16.1-1.8,1.7,38.8,39,40.2,41,4.5,4.4,11.4,4.8,16.4,1L187.1,21.4l-53.6,166.8c-.4,1.6-2.7,2.3-3.9,1.1l-49.5-44.6c-5.4-5.2-15-.9-14.8,6.6v33.5c0,4.9,4,8.8,8.8,8.9,2.3,0,4.5-.9,6.2-2.5l17.4-16.9,25.1,22.6c6.4,6.1,18,3,20.4-5.5L199.3,16.4c2.1-6.6-1.5-13.7-8.1-15.8ZM51.2,113.1c-.9.7-2.3.6-3.1-.2L10.9,76.7c-.9-.9-1-2.4,0-3.4.5-.9,171.5-61.3,172.4-61.8L51.2,113.1ZM75.4,181.6v-27.4l14.6,13.2-14.6,14.2Z"
  })));
};
export default SvgSend;